import React, { Component } from "react";
import { connect } from "react-redux";

import QuyHoach from "./SearchBody/QuyHoach";
import SoTo from "./SearchBody/SoTo";
import ToaDo from "./SearchBody/ToaDo";
import DiaChi from "./SearchBody/DiaChi";
import {
  getDataDuAn,
  getDataDuong,
  getDataPhuong,
  getDataQuan,
} from "../../../redux/actions/search.action";
import { Tabs } from "antd";

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "SoTo",
    };
  }

  componentDidMount() {
    if (this.props.listQuan.length === 0) this.props.getDataQuan();
    if (this.props.listPhuong.length === 0) this.props.getDataPhuong();
    if (this.props.listDuong.length === 0) this.props.getDataDuong();
    if (this.props.listDuAn.length === 0) this.props.getDataDuAn();
  }

  changeTab = (id) => {
    this.setState({ activeTab: id });
  };

  render() {
    return (
      <div className="popup-search">
        <div className="title font-size-16">
          Tìm kiếm thông tin
          <i
            className="fas fa-times icon-close"
            onClick={() => {
              this.props.close();
            }}
          ></i>
        </div>

        <Tabs
          activeKey={this.state.activeTab}
          onChange={(e) => {
            this.changeTab(e);
          }}
        >
          <Tabs.TabPane key="SoTo" tab={<div style = {{width: 
            // localStorage.loginSession ? '66px' : '100px'
            '100px'
            , textAlign: "center"}}>Số tờ</div>}>
            <div className="body">
              {this.state.activeTab === "SoTo" && (
                <SoTo
                  listQuan={this.props.listQuan}
                  listPhuong={this.props.listPhuong}
                  onSearch={this.props.searchBySoTo}
                ></SoTo>
              )}
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane key="ToaDo" tab={<div style = {{width: '100px', textAlign: "center"}}>Toạ độ</div>}>
            <div className="body">
              {this.state.activeTab === "ToaDo" && (
                <ToaDo
                  drawPolygonSearch={this.props.drawPolygonSearch}
                  onSearch={this.props.searchByToaDo}
                  resetMap={this.props.resetMap}
                ></ToaDo>
              )}
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane key="DiaChi" tab={<div style = {{width: '100px', textAlign: "center"}}>Địa chỉ</div>}>
            <div className="body">
              {this.state.activeTab === "DiaChi" && (
                <DiaChi
                  listQuan={this.props.listQuan}
                  listPhuong={this.props.listPhuong}
                  listDuong={this.props.listDuong}
                  onSearch={this.props.searchByDiaChi}
                ></DiaChi>
              )}
            </div>
          </Tabs.TabPane>

          {/* {localStorage.loginSession &&  <Tabs.TabPane key="QuyHoach" tab={<div style = {{width: '82px', textAlign: "center"}}>Quy hoạch</div>}>
            <div className="body">
              {this.state.activeTab === "QuyHoach" && (
                <QuyHoach
                  listQuan={this.props.listQuan}
                  listPhuong={this.props.listPhuong}
                  listDuAn={this.props.listDuAn}
                  onSearch={this.props.searchByDuAn}
                ></QuyHoach>
              )}
            </div>
          </Tabs.TabPane>} */}
        </Tabs>

        <div className="footer">
          <div style={{ display: "flex" }}>
            <div className="required">*</div>
            <div className="text">Thông tin bắt buộc</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    listQuan: state.search.listQuan,
    listPhuong: state.search.listPhuong,
    listDuong: state.search.listDuong,
    listDuAn: state.search.listDuAn,
  };
};

const mapDispatchToProps = {
  getDataQuan: getDataQuan,
  getDataPhuong: getDataPhuong,
  getDataDuong: getDataDuong,
  getDataDuAn: getDataDuAn,
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
